import { Component } from "react";

// Diagnose-/Sicherheits-Boundary. Fängt zwei Fehlerarten und zeigt sie als
// lesbares Overlay auf dem Bildschirm an, statt schwarz zu werden:
//   1) React-Render-/Lifecycle-/useFrame-Fehler  → componentDidCatch
//   2) globale Fehler aus Event-Handlern / async / GSAP / Promises
//      → window "error" + "unhandledrejection" (die fängt React NICHT ab!)
// Wenn iOS-Chrome an einer Stelle "schwarz" wird und HIER eine Meldung
// erscheint, ist es ein JS-Fehler (den wir dann wörtlich haben). Bleibt es
// trotz Boundary schwarz, war es ein Prozess-Kill (WKWebView-Speicherlimit),
// kein JS-Fehler.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: "" };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info: info?.componentStack || "" });
  }

  componentDidMount() {
    this.onError = (e) => {
      const err = e.error || e.message || "Unbekannter Fehler";
      this.setState({
        error: err instanceof Error ? err : new Error(String(err)),
        info: `${e.filename || ""}:${e.lineno || "?"}:${e.colno || "?"}`,
      });
    };
    this.onRejection = (e) => {
      const r = e.reason;
      this.setState({
        error: r instanceof Error ? r : new Error("Unhandled promise: " + String(r)),
        info: "unhandledrejection",
      });
    };
    window.addEventListener("error", this.onError);
    window.addEventListener("unhandledrejection", this.onRejection);
  }

  componentWillUnmount() {
    window.removeEventListener("error", this.onError);
    window.removeEventListener("unhandledrejection", this.onRejection);
  }

  render() {
    if (this.state.error) {
      const { error, info } = this.state;
      return (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 999999,
            background: "rgba(10,10,12,0.97)",
            color: "#fff",
            font: "13px/1.4 monospace",
            padding: "16px",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div style={{ color: "#fc8207", fontWeight: 700, marginBottom: 8 }}>
            App-Fehler abgefangen
          </div>
          <div style={{ marginBottom: 8, wordBreak: "break-word" }}>
            {String(error?.message || error)}
          </div>
          {error?.stack && (
            <pre style={{ whiteSpace: "pre-wrap", opacity: 0.8, wordBreak: "break-word" }}>
              {error.stack}
            </pre>
          )}
          {info && (
            <pre style={{ whiteSpace: "pre-wrap", opacity: 0.6, wordBreak: "break-word" }}>
              {info}
            </pre>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 12,
              padding: "10px 18px",
              borderRadius: 24,
              border: "1px solid #fc8207",
              background: "transparent",
              color: "#fff",
            }}
          >
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
